import { useEffect, useState } from 'react';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import Typography from '@mui/material/Typography';
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';
import styles from '../../../../TerminateEmployeeAccess.module.scss';
import { getMobileDevicesByUser } from '../../../../_api';
import { DataTable } from '../../../../../../../../../components/UI/MDC/DataTable/DataTable';
import Spinner from '../../../../../../../../../components/UI/Spinner/Spinner';
const ReviewMobileDevices = ({ staffMember, index, formik }) => {
	const [isLoading, setIsLoading] = useState(false);
	useEffect(() => {
		setIsLoading(true);
		if (
			staffMember?.fiId &&
			(!staffMember.mobileDevices ||
				staffMember.mobileDevices.length === 0)
		) {
			getMobileDevicesByUser(staffMember.fiId).then(response => {
				let formikStaffMember =
					formik.values.staffMembersForReview[index];
				formikStaffMember.mobileDevices = response.data.payload;
				//update formik state with user applications
				let updatedFormikStaffMembers = [
					...formik.values.staffMembersForReview,
				];
				updatedFormikStaffMembers.splice(index, 1, formikStaffMember);
				formik.setFieldValue('staffMembersForReview', [
					...updatedFormikStaffMembers,
				]);
				setIsLoading(false);
			});
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	const MobileDevicesTable = {
		headers: [
			{
				Value: 'Number',
				props: { sort: null, onSortChange: null },
			},
			{
				Value: 'Type',
				props: { sort: null, onSortChange: null },
			},
		],
		rows: staffMember.mobileDevices?.map((device, index) => {
			return {
				Cells: {
					Number: {
						Value: device.number,
						Validation: {
							Key: 'true',
							Value: null,
							memberToValidateKey: null,
						},
					},
					Type: {
						Value: device.type,
						Validation: {
							Key: 'true',
							Value: null,
							memberToValidateKey: null,
						},
					},
					Key: device.number.toString(),
				},
			};
		}),
	};

	return (
		<>
			<div className={styles.margin_top_small}>
				<Accordion className={styles.accordion}>
					<AccordionSummary
						className={styles.accordion_summary_secondary}
						expandIcon={
							<ArrowDownwardIcon
								className={styles.accordion_summary_secondary}
							/>
						}
						aria-controls={'StaffMember-content-' + index}
						id={'StaffMember-header-' + index}
					>
						<Typography>Mobile Devices</Typography>
					</AccordionSummary>
					<AccordionDetails className={styles.accordion_details}>
						{isLoading ? (
							<Spinner />
						) : (
							<>
								{staffMember?.mobileDevices &&
								staffMember.mobileDevices.length > 0 ? (
									<DataTable
										rows={MobileDevicesTable.rows}
										headers={MobileDevicesTable.headers}
									/>
								) : (
									<p>no mobile devices found for this user</p>
								)}
							</>
						)}
					</AccordionDetails>
				</Accordion>
			</div>
		</>
	);
};

export default ReviewMobileDevices;
